import React, { Component } from 'react'
import { withRouter } from "react-router-dom";

class Header extends Component {
  settingClickHandler = () => {
    const deviceName = localStorage.getItem('deviceName');
    localStorage.clear();
    this.props.history.push('/', {deviceName});
  }

  render() {
    return (
        <div className="w-100 d-flex justify-content-center blockquote p-2 header-bar">
          <span className="text-black center display-50 ml-auto mr-auto">Green Cloud Signer</span>
          <button className="btn btn-outline-danger align-self-end" onClick={this.settingClickHandler}><i
              className="fa fa-cog"/></button>
        </div>
    );
  }
}

export default withRouter(Header);
